var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AreaContainer',[_c('AreaNav',{attrs:{"links":_vm.links}}),_c('AreaContent',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }